<template>
  <h3
    :class="titleClass"
    class="font-druk font-medium text-display-10 md:text-display-14 uppercase tracking-wide leading-9 md:leading-12"
    :style="{color: titleColor ? titleColor: ''}"
  >
    {{ title }}
  </h3>
</template>

<script>
export default {
  props: {
    /**
     * The text that you want displayed
     */
    title: {
      type: String,
      required: true
    },
    /**
     * If the text should be light or dark
     */
    textVariant: {
      type: String,
      default: null,
      validator: val => ['light', 'dark', 'gray', 'null'].includes(val)
    },
    titleColor: {
      type: String,
      default: ''
    },
    /**
     * Allows you to specify spacing in different directions.
     */
    spacing: {
      type: String,
      default: null,
      validator: val => ['horizontal', 'vertical', 'top', 'right', 'bottom', 'left'].includes(val)
    }
  },
  computed: {
    titleClass () {
      const classes = []
      if (this.textVariant === 'light') { classes.push('text-white') }
      switch (this.spacing) {
        case 'horizontal':
          classes.push('mx-4')
          break
        case 'vertical':
          classes.push('my-6 md:my-8')
          break
        case 'top':
          classes.push('mt-6 md:mt-8')
          break
        case 'right':
          classes.push('mr-4')
          break
        case 'bottom':
          classes.push('mb-6 md:mb-8')
          break
        case 'left':
          classes.push('ml-4')
          break
        default:
          break
      }
      return classes.join(' ')
    }
  }
}
</script>
